import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Badge } from 'reactstrap';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { connect } from 'react-redux';
import { setCheckout, setCart } from '../../../../redux/store/store.actions';
import {
  setIsCheckoutModalOpen,
  setIsPickupStatusModalOpen,
} from '../../../../redux/modal/modal.actions';
import PropTypes from 'prop-types';
import { setPickupOrder } from '../../../../redux/me/me.actions';
import { baseGetQuery } from '../../../../utility/sb-api/sb-api.service';
import * as Icon from 'react-feather';

const PickupStatusModal = ({
  isOpen,
  store,
  pickupOrder,
  intl,

  setIsPickupStatusModalOpen,
  setPickupOrder,
}) => {
  const refreshInterval = 30;
  const [refreshStatusIn, setRefreshStatusIn] = useState(refreshInterval);
  const [isOrderReadyForPickup, setIsOrderReadyForPickup] = useState(false);

  const getOrderStatus = () => {
    baseGetQuery(`user/orders/${pickupOrder?.id}`).then((order) => {
      if (order?.status === 'prepared') {
        setIsOrderReadyForPickup(true);
        setPickupOrder(order);
      }
    });
  };

  useEffect(() => {
    if (pickupOrder) {
      const interval = setInterval(() => {
        if (refreshStatusIn === 0) {
          getOrderStatus();
          setRefreshStatusIn(refreshInterval);
        } else {
          setRefreshStatusIn(refreshStatusIn - 1);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [getOrderStatus, pickupOrder, refreshStatusIn]);

  return (
    <ModalSheet
      isOpen={isOpen}
      closeModal={() => setIsPickupStatusModalOpen(false)}
      title={intl.formatMessage({ id: 'checkout_success_title_pickup' })}
    >
      <div className="px-1 py-1 text-center">
        <span className="d-block mb-2">
          <FormattedMessage
            values={{ restaurant_name: store?.name }}
            id="checkout_success_text_pickup"
          />
        </span>
        <Badge
          color={isOrderReadyForPickup ? 'primary' : 'secondary'}
          className="badge-xl"
        >
          <span>
            {isOrderReadyForPickup ? (
              <FormattedMessage id="checkout_success_tag_pickup_ready" />
            ) : (
              <FormattedMessage id="checkout_success_tag_pickup_pending" />
            )}
          </span>
        </Badge>
        {isOrderReadyForPickup ? (
          <span className="d-block my-2">
            <FormattedMessage id="checkout_success_text_pickup_ready" />
            <b>{pickupOrder?.number}</b>
          </span>
        ) : (
          <span className="d-block my-2">
            <FormattedMessage
              values={{ seconds: refreshStatusIn }}
              id="checkout_success_text_pickup_pending"
            />
            <b>{pickupOrder?.number}</b>. Du kannst deinen Status über das{' '}
            <Icon.Clock
              size={16}
              className={
                pickupOrder?.status === 'prepared' ? 'primary' : 'warning'
              }
              data-tour="search"
            />{' '}
            Symbol in der Menüleiste verfolgen.
          </span>
        )}
      </div>
    </ModalSheet>
  );
};

PickupStatusModal.propTypes = {
  isOpen: PropTypes.bool,
  store: PropTypes.object,
  pickupOrder: PropTypes.object,
  intl: PropTypes.object,
  setIsPickupStatusModalOpen: PropTypes.func,
  setPickupOrder: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isPickupStatusModalOpen,
  store: state.store.store,
  pickupOrder: state.me.pickupOrder,
});

export default connect(mapStateToProps, {
  setIsCheckoutModalOpen,
  setCheckout,
  setCart,
  setPickupOrder,
  setIsPickupStatusModalOpen,
})(injectIntl(PickupStatusModal));
